<template>
  <div class="notice-item">
    <div class="notice-item-title">
      <p>通知公告</p>
    </div>
    <div class="notice-item-content">
      <div style="display: flex; width: 100%">
        <el-tabs
          v-model="activeName"
          style="width: 100%"
          @tab-click="handleClick"
        >
          <el-tab-pane label="赛事通知" name="0">
            <div
              v-for="(item, index) in list.slice(0,4)"
              :key="index"
              class="item"
              @click="handleShowDetail(item)"
            >
              <div class="time" v-if="item.releaseDate">
                {{ dayjs(item.releaseDate).format("MM/DD") }}
              </div>
              <div class="time" v-else>

              </div>
              <div class="line" />
              <div class="content">
                <div>{{ item.title }}</div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="赛区通知" name="1">
            <div
              v-for="(item, index) in list.slice(0,4)"
              :key="index"
              class="item"
              @click="handleShowDetail(item)"
            >
            <div class="time" v-if="item.releaseDate">
                {{ dayjs(item.releaseDate).format("MM/DD") }}
              </div>
              <div class="time" v-else>

              </div>
              <div class="line" />
              <div class="content">
                <div>{{ item.title }}</div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="operation" @click="handleShowMore">查看更多>></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  components: {},
  props: {},
  data () {
    return {
      list: [],
      activeName: '0'
    }
  },
  mounted () {
    this.getNoticeContent('sstz')
  },
  methods: {
    dayjs,
    handleShowMore () {
      this.$router.push({ path: '/trends' })
    },
    handleShowDetail (item) {
      let routeUrl = this.$router.resolve({
        path: '/detail',
        query: { id: item.id }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleClick (tab) {
      this.activeName = tab.name
      if (tab.name === '0') {
        this.getNoticeContent('sstz')
      } else {
        this.getNoticeContent('sqtz')
      }
    },
    getNoticeContent (path) {
      var url =
        this.siteURL +
        '/actuator/channel/list?siteId=' +
        this.siteId +
        '&url=/' + path
      this.axios.get(url, {}).then(response => {
        this.channelId = response.data.rows[0].id
        var api =
          this.siteURL + '/actuator/article/indexList?channelId=' + this.channelId
        this.axios.get(api, {}).then(response => {
          console.log('responseTzgg', response)
          this.list = response.data.rows
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-title {
    width: 43%;
    height: 78px;
    background-image: url("~@/assets/images/title_bg.png");
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    p {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      text-align: right;
      font-style: normal;
      margin-left: 110px;
      margin-top: 18px;
    }
  }

  &-content {
    width: 100%;
    height: 470px;
    position: relative;
    background-image: url("~@/assets/images/notice_bg.png");
    background-position: center;
    background-size: 100% 100%;
    margin-top: 3px;
    margin-left: 22px;
    padding: 30px;

    ::v-deep .el-tabs__item {
      font-size: 24px;
      color: #343f51;
    }

    ::v-deep .el-tabs__item:hover {
      color: #00a1bb;
    }

    ::v-deep .is-active {
      font-size: 24px;
      color: #00a1bb;
    }

    ::v-deep .el-tabs__nav-wrap::after {
      background-color: #bad2dc;
    }

    ::v-deep .el-tabs__active-bar {
      background-color: #00a1bb;
    }

    .operation {
      padding: 8px;
      display: flex;
      // width: 20%;
      position: absolute;
      right: 30px;
      top: 24px;
      margin-top: 4px;
      justify-content: flex-end;
      height: 36px;
      opacity: 1;
      font-family: MicrosoftYaHei;
      font-size: 18px;
      color: #0061FF;
      line-height: 24px;
      text-align: right;
      font-style: normal;

      &:hover {
        cursor: pointer;
      }
    }

    .item {
      margin-top: 15px;
      padding: 10px;
      height: 70px;
      // background-image: url("~@/assets/images/notice_item_bg.png");
      background: linear-gradient(270deg,
          rgba(241, 247, 255, 0) 0%,
          rgba(239, 246, 255, 0.55) 10%,
          #ecf4fe 100%);
      box-shadow: 0px 2px 4px 0px #d5e5f7;
      background-size: 100% 100%;
      background-position: center;
      display: flex;
      align-items: center;

      .time {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #343f51;
        line-height: 24px;
        font-style: normal;
        margin-left: 6px;
        display: flex;
        justify-content: center;
        width: 6%;
      }

      .line {
        width: 1px;
        height: 30px;
        background: #ddd;
        margin: 0 20px;
      }

      .content {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #343f51;
        line-height: 21px;
        font-style: normal;
      }

      &:hover {
        // background-image: url("~@/assets/images/notice_item_select_bg.png");
        background-size: 100% 100%;
        background-position: center;
        color: #ffffff;
        cursor: pointer;
        border: 1px solid #00a1bb;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .notice-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-title {
      width: 80%;
      height: 78px;
      background-image: url("~@/assets/images/title_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

      p {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        text-align: right;
        font-style: normal;
        margin-left: 120px;
      }
    }

    .operation {
      font-size: 14px;
      position: absolute;
      right: 10px;
      top: 0;
    }

    .notice-item-content {
      padding: 0;
      margin-left: 0;
      margin-top: 20px;
      height: 410px;
      background-image: url();

      .time {
        width: 32px;
        font-size: 14px;
      }

      .line {
        margin: 10px;
      }

      .content {
        width: 80%;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part2/NoticeItem.vue